import React from 'react';
import PropTypes from 'prop-types';

import getSortDisplayTypeComponent from 'features/sort/getSortDisplayTypeComponent';

function AppSortAttributeFilters ({
	className,
	filterDisplayTypeId,
	defaultVisibleMenuCount,
	attributeGroups,
	appliedFilters
}) {

	const SortDisplayTypeComponent = getSortDisplayTypeComponent(filterDisplayTypeId);

	return (
		<SortDisplayTypeComponent
			className={className}
			attributeGroups={attributeGroups}
			defaultVisibleMenuCount={defaultVisibleMenuCount}
			appliedFilters={appliedFilters}
		/>
	);

}

AppSortAttributeFilters.propTypes = {
	className: PropTypes.string,
	filterDisplayTypeId: PropTypes.number,
	defaultVisibleMenuCount: PropTypes.number,
	attributeGroups: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object)]).isRequired,
	appliedFilters: PropTypes.oneOfType([
		PropTypes.arrayOf(
			PropTypes.shape({
				Name: PropTypes.string,
				AttributeValues: PropTypes.arrayOf(PropTypes.string),
				StepbackLink: PropTypes.string
			})
		)
	]),
};

export default AppSortAttributeFilters;
